import React from 'react';
import { useTranslation } from 'react-i18next';
import Modal from '@material-ui/core/Modal';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { PropTypes } from 'prop-types';
import { palette } from '../../../system/styles/styles';

const NewVacante = (props) => {
  const { open, close, className, link } = props;
  const { t } = useTranslation(['jobs']);

  const [clase, setClase] = React.useState('');
  const [claseHunting, setClasehunting] = React.useState('');
  const closed = () => {
    close();
    setClase('');
    setClasehunting('');
  };

  const goToEmail = () => {
    document.location.href = `mailto:pol@lapieza.io`;
    closed();
  };

  return (
    <Modal
      aria-labelledby="spring-modal-title"
      aria-describedby="spring-modal-description"
      open={open}
      className={className}
      onClose={close}>
      <div className="containerNew">
        <header>
          <h1>{t('CreateHeader')}</h1>
          <button type="button" onClick={close}>
            X
          </button>
        </header>
        <div className="bodyNew">
          <Link onClick={() => closed()} to={link || '/'}>
            <div onMouseEnter={() => setClase('normalText')} onMouseLeave={() => setClase('')}>
              <img
                src="https://firebasestorage.googleapis.com/v0/b/lapieza-production.appspot.com/o/imgDefault%2FGrupo%202565.png?alt=media&token=8b9a5781-db3b-43b1-8b00-9a9673fc52b6"
                alt="Vacante normal"
              />
              <h2>{t('RegularVacancy')}</h2>
              <p className={`desc ${clase}`}>{t('RegularDescription')}</p>
            </div>
          </Link>
          <Link onClick={() => goToEmail()} to="#">
            <div onMouseEnter={() => setClasehunting('normalText')} onMouseLeave={() => setClasehunting('')}>
              <img
                src="https://firebasestorage.googleapis.com/v0/b/lapieza-production.appspot.com/o/imgDefault%2FGrupo%202567.png?alt=media&token=8636129b-8ad5-44f8-83f7-10a714600475"
                alt="Headhunting"
              />
              <h2>{t('Headhunting')}</h2>
              <p className={`desc ${claseHunting}`}>{t('HuntingDescription')}</p>
            </div>
          </Link>
        </div>
      </div>
    </Modal>
  );
};

NewVacante.propTypes = {
  className: PropTypes.string,
  open: PropTypes.bool,
  link: PropTypes.string,
  // linkOperative: PropTypes.string,
  close: PropTypes.func,
  creditos: PropTypes.number,
  creditosRestantes: PropTypes.number,
  plan: PropTypes.string,
  linkPrescreening: PropTypes.string,
};

NewVacante.defaultProps = {
  className: '',
  open: false,
  link: '',
  // linkOperative: '',
  close: () => {},
  creditos: 0,
  creditosRestantes: 0,
  plan: '',
  linkPrescreening: '',
};

export default styled(NewVacante)`
  display: flex;
  justify-content: center;
  align-items: center;
  .normalText {
    font-size: 16px !important;
    letter-spacing: 0.2px;
    line-height: 2;
    width: 90%;
  }
  .containerNew {
    max-height: 80vh;
    background-color: ${palette.white};
    overflow-y: auto;
    border-radius: 8px;
    width: 50vw;
    &:focus {
      outline: none;
    }
    &:active {
      outline: none;
    }
  }
  header {
    height: 60px;
    background-color: #1d1d38;
    border-top-right-radius: 8px;
    border-top-left-radius: 8px;
    display: flex;
    flex-direction: column;
    position: relative;
    justify-content: center;
    h1 {
      font-size: 16px;
      color: ${palette.white};
      text-align: center;
      margin: 0px;
    }
    p {
      margin: 0px;
      text-align: center;
      strong {
        font-weight: 400;
        font-size: 12px;
        color: ${palette.white};
      }
    }
    button {
      height: 30px;
      width: 50px;
      position: absolute;
      right: 0px;
      top: 50%;
      transform: translateY(-50%);
      font-size: 16px;
      font-weight: bold;
      padding: 0;
      margin: 0px;
      background-color: transparent;
      color: ${palette.white};
      border: none;
      cursor: pointer;
      &:focus {
        outline: none;
      }
      &:active {
        outline: none;
      }
    }
  }
  .bodyNew {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    grid-column-gap: 3rem;
    padding: 40px 30px;
    margin-top: 50px;
    min-height: 240px;
    font-family: ${palette.nereg};
    a {
      //height: 160px;
      width: 90%;
      border-radius: 8px;
      padding: 20px;
      background-color: #a3cbbd;
      text-decoration: none;
      transition: 0.3s;
      img {
        width: 100%;
        max-height: 100px;
        height: 100%;
        transform: translateY(-50%);
        object-fit: contain;
      }
      p {
        padding-top: 20px;
        font-size: 0px;
        transition: 0.3s;
        text-align: center;
      }
      h2 {
        font-size: 18px;
        text-align: center;
        transition: 0.3s;
        font-weight: 400;
      }
      &:hover {
        background-color: #014d43;
        p,
        h2 {
          color: white;
        }
      }
    }
    desc {
      margin-top: 15px;
      font-size: 0.9rem;
      text-align: center;
    }
  }
`;
